import MultiStepQuestionnaire from "./MultiStepQuestionnaire";

export default MultiStepQuestionnaire;
